export default "__VITE_ASSET__DKIrOlyt__"